import type { Recipient } from "src/types";

/** Email used to send the questionnaire (account holder or same-person linked patient). */
export function getRecipientQuestionnaireEmail(
    recipient: Recipient | null | undefined,
    formEmail?: string,
): string {
    const direct = (formEmail?.trim() || recipient?.email?.trim() || "");
    if (direct) return direct;

    const sameId = recipient?.sameAsPatientId?.trim();
    if (!sameId || !recipient?.patients?.length) return "";

    const same = recipient.patients.find((p) => p.id === sameId);
    if (same?.email?.trim()) return same.email.trim();

    const withEmail = recipient.patients.filter((p) => p.email?.trim());
    if (withEmail.length === 1) return withEmail[0].email!.trim();

    return "";
}
